import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

const steps = [
	{
		label: "Package recieved at origin facility",
		description: `For each ad campaign that you create, you can control how much
              you're willing to spend on clicks and conversions, which networks
              and geographical lgermanyocations you want your ads to show on, and more.`,
		location: "germany",
		Date: "24 may 2025",
		Time: "04:55 pm",
	},
	{
		label: "Dispatched from sorting center",
		description:
			"An ad group contains one or more ads which target a shared set of keywords.",
		location: "egypt",
		Date: "24 may 2025",
		Time: "04:55 pm",
	},
	{
		label: "Arrived at destination facility",
		description: `Try out different ad text to see what brings in the most customers,
              and learn how to enhance your ads using features like ad extensions.
              If you run into any problems with your ads, find out how to tell if
              they're running and how to resolve approval issues.`,
		location: "france",
		Date: "24 may 2025",
		Time: "04:55 pm",
	},

	{
		label: "Out for pickup",
		description: `Try out different ad text to see what brings in the most customers,
              and learn how to enhance your ads using features like ad extensions.
              If you run into any problems with your ads, find out how to tell if
              they're running and how to resolve approval issues.`,
		location: "brazil",
		Date: "24 may 2025",
		Time: "04:55 pm",
	},
];

export default function PackageTrackingStepper(props) {
	const { steps } = props;
	const [activeStep, setActiveStep] = React.useState(0);

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleReset = () => {
		setActiveStep(0);
	};

	return (
		<Box sx={{ maxWidth: 400 }}>
			<Stepper activeStep={activeStep} orientation="vertical">
				{steps.map((step, index) => (
					<Step key={step?._id}>
						<StepLabel
							optional={
								index === steps.length - 1 ? (
									<Typography variant="caption">Last step</Typography>
								) : null
							}>
							<span className="font-normal">Location: {step?.location}</span>
						</StepLabel>
						<StepContent>
							{/* <Typography>{step.description}</Typography> */}
							<div>
								<ul className="text-gray-500   text-[0.8rem] py-[0.2rem]">
									<li className="text-black ">
										<span className=" font-medium  mr-[0.3rem]">Status:</span>
										{step?.status}
									</li>

									<li className="   border-y-2  text-[0.8rem] border-y-gray-300  py-[0.2rem]   text-black ">
										<span className=" font-medium  mr-[0.3rem]">Date:</span>{" "}
										{step?.date}
									</li>
									<li className="text-black  text-[0.8rem]  border-b-2  border-b-gray-300  py-[0.2rem]">
										<span className=" font-medium  mr-[0.3rem]"> Time:</span>{" "}
										{step?.time}
									</li>
								</ul>
							</div>
							<Box sx={{ mb: 2 }}>
								<Button
									variant="contained"
									onClick={handleNext}
									sx={{ mt: 1, mr: 1 }}>
									{index === steps.length - 1 ? "Finish" : "Continue"}
								</Button>
								<Button
									disabled={index === 0}
									onClick={handleBack}
									sx={{ mt: 1, mr: 1 }}>
									Back
								</Button>
							</Box>
						</StepContent>
					</Step>
				))}
			</Stepper>
			{activeStep === steps.length && (
				<Paper square elevation={0} sx={{ p: 3 }}>
					{/* <Typography>Shipmet </Typography> */}
					<Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
						Review
					</Button>
				</Paper>
			)}
		</Box>
	);
}
